import { render, staticRenderFns } from "./TransferirManifestacao.vue?vue&type=template&id=dc735956&"
import script from "./TransferirManifestacao.vue?vue&type=script&lang=js&"
export * from "./TransferirManifestacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports